






















































































































































import { Component, Vue } from 'vue-property-decorator';
import Card from '@/components/Card.vue';
import Quest from '@/components/Quest.vue';
import ScheduledLoot from '@/components/ScheduledLoot.vue';
import restService from '../services/rest.service';
import websiteService from '../services/website.service';
import moment from 'moment';
import optionsService from '../services/options.service';
import authService from '../services/auth.service';
import wizardService from '@/services/wizard.service';
import { IQuest } from '@thefirstspine/types-rest';
import calendarService from '@/services/calendar.service';

@Component({
  components: {
    Card,
    Quest,
    ScheduledLoot,
  },
})
export default class Home extends Vue {
  public async mounted() {
    // Test for language
    if (optionsService.options.language === '') {
      this.$router.push('/select-language');
      return;
    }

    // Test for auth
    try {
      await authService.me();
    } catch (e) {
      this.$router.push('/login');
      return;
    }

    // Test for realm
    if (optionsService.options.realm === '') {
      this.$router.push('/select-realm');
      return;
    }

    // Load wizard
    this.$data.wizard = await wizardService.getMe();

    // Load cycle
    this.$data.cycle = await calendarService.currentCycle();
    this.$data.cycleMessageHidden =
      window.localStorage.getItem(`cycleMessageHidden-${this.$data.cycle.name}`) === 'true' ? true : false;

    // Load quests
    const quests = await restService.quests();
    this.$data.dailyQuest = quests.daily;
    this.$data.weeklyQuest = quests.weekly;

    // Load event
    try {
      const events = (await calendarService.currentEvents());
      if (events && events.length) {
        this.$data.event = events[0];
        this.$data.eventMessageHidden =
          window.localStorage.getItem(`eventMessageHidden-${this.$data.event.id}`) === 'true' ? true : false;
      }
    } catch (e) {
      // do nothing
    }

    try {
      // Load news
      this.$data.news = (await websiteService.news(this.$i18n.locale)).reverse().splice(0, 3);
    } catch (e) {
      // do nothing
    }

    try {
      const scheduledLoot = await calendarService.scheduledLoot();
      if (scheduledLoot?.rewarded) {
        this.$data.scheduledLoot = scheduledLoot;
      }
    } catch (e) {
      // do nothing
    }
  }

  public data() {
    return {
      cycleMessageHidden: true,
      cycle: null,
      options: optionsService.options,
      env: process.env.VUE_APP_ENV,
      news: [],
      eventMessageHidden: true,
      event: null,
      scheduledLoot: null,
      newsBaseUrl: `${process.env.VUE_APP_WEBSITE_URL}/blog/`,
      dailyQuest: null,
      weeklyQuest: null,
      wizard: null,
    };
  }

  public hideCycleMessage() {
    this.$data.cycleMessageHidden = true;
    window.localStorage.setItem(`cycleMessageHidden-${this.$data.cycle.name}`, 'true');
  }

  public hideEventMessage() {
    this.$data.eventMessageHidden = true;
    window.localStorage.setItem(`eventMessageHidden-${this.$data.event.id}`, 'true');
  }

  public toReadableDate(timestamp: number) {
    return moment(timestamp * 1000).format(this.$t('app.dateFormat').toString());
  }

  public async takeQuest(quest: IQuest) {
    this.$data.wizard.quests.push(quest.id);
    try {
      await wizardService.setMe({
        quests: this.$data.wizard.quests,
      });
    } catch (e) {
      // do nothing
    }
    this.$data.wizard = await wizardService.getMe();
  }

  public hasTakenQuest(quest: IQuest) {
    return this.$data.wizard.quests.includes(quest.id);
  }
}
